import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { TableControls } from '../../BaseEditor';
import { decimalFormat } from '../../../api/utils';

function Row({
  row, rowChange, rowSave,
}) {
  return (
    <>
      <TableRow
        hover
        style={{ background: row.save ? '#baf3bab3' : 'white' }}
      >
        <TableCell rowSpan="2" sx={{ textAlign: 'center' }}>
          <TableControls.CheckboxInput
            noMargin
            value={row.save}
            onChange={() => rowSave(row.id, { save: !row.save })}
          />
        </TableCell>
        <TableCell>
          <TableControls.ItemPicker
            label={null}
            backend="/api/catalog/payers/"
            canErase
            value={row.payer}
            onChange={(e, v) => rowChange(row.id, { payer: v })}
          />
        </TableCell>
        <TableCell>
          <TableControls.ItemPicker
            label={null}
            backend="/api/catalog/contracts/"
            canErase
            value={row.contract}
            onChange={(e, v) => rowChange(row.id, { contract: v })}
          />
        </TableCell>
        <TableCell sx={{ textAlign: 'right' }}>
          {decimalFormat(row.order_amount)}
        </TableCell>
        <TableCell sx={{ textAlign: 'right' }}>
          {decimalFormat(row.revenue_amount)}
        </TableCell>
      </TableRow>
      <TableRow
        sx={{ background: row.save ? '#baf3bab3' : 'white' }}
      >
        <TableCell colSpan="4">
          {row.payment_notes}
        </TableCell>
      </TableRow>
    </>

  );
}
Row.propTypes = {
  row: PropTypes.shape().isRequired,
  rowChange: PropTypes.func.isRequired,
  rowSave: PropTypes.func.isRequired,
};

export default memo(Row);
